export const MATCH_TIMEZONE = 'Europe/Rome';

function getTimeZoneOffsetMs(timeZone, date) {
  const dtf = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
  const parts = dtf.formatToParts(date);
  const values = {};
  for (const part of parts) {
    if (part.type !== 'literal') values[part.type] = part.value;
  }
  const asUtc = Date.UTC(
    Number(values.year),
    Number(values.month) - 1,
    Number(values.day),
    Number(values.hour),
    Number(values.minute),
    Number(values.second),
  );
  return asUtc - date.getTime();
}

/** Interprète date + heure comme heure locale en Italie (Europe/Rome). */
export function parseDateTimeInTimeZone(dateStr, timeStr, timeZone = MATCH_TIMEZONE) {
  if (!dateStr) return null;
  const time = timeStr || '00:00';
  const [y, m, d] = dateStr.split('-').map(Number);
  const [hh, mm] = time.split(':').map(Number);
  const utcGuess = Date.UTC(y, m - 1, d, hh, mm, 0);
  const offset = getTimeZoneOffsetMs(timeZone, new Date(utcGuess));
  return new Date(utcGuess - offset);
}

export function formatMatchDateTime(value, locale = 'fr-FR', options = {}) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString(locale, {
    timeZone: MATCH_TIMEZONE,
    ...options,
  });
}

export function formatMatchDate(value, locale = 'fr-FR') {
  return formatMatchDateTime(value, locale, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatMatchDateOnly(value, locale = 'fr-FR') {
  return formatMatchDateTime(value, locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function formatMatchDateParts(value, locale = 'fr-FR') {
  if (!value) return { dateLine: '', timeLine: '' };
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return { dateLine: '', timeLine: '' };
  const dateLine = d
    .toLocaleDateString(locale, {
      timeZone: MATCH_TIMEZONE,
      weekday: 'long',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
    .replace(/^\w/, (c) => c.toUpperCase());
  const timeLine = d.toLocaleTimeString(locale, {
    timeZone: MATCH_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
  });
  return { dateLine, timeLine };
}

export function formatMatchPhaseRange(startDate, endDate, locale = 'fr-FR') {
  const opts = {
    timeZone: MATCH_TIMEZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };
  const start = new Date(startDate).toLocaleString(locale, opts);
  const end = new Date(endDate).toLocaleString(locale, opts);
  return `${start} - ${end}`;
}

export function splitDateTimeForInput(value, timeZone = MATCH_TIMEZONE) {
  if (!value) return { date: '', time: '' };
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return { date: '', time: '' };
  const date = d.toLocaleDateString('en-CA', { timeZone });
  const time = d.toLocaleTimeString('en-GB', {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  return { date, time };
}
